import React from 'react';
import { Button, Dropdown, Form } from '@bynder/design-system';
import {
  SECTION_MAX_HEIGHT,
  SECTION_MIN_HEIGHT,
} from '../../../../constants/sections';
import { StyledInput } from '../../Styles';
import { getValueFromStyles, splitValueAndUnit } from '../helpers';
import { CSS_PROPERTIES } from '../constants';
import { HEIGHT_UNITS } from '../../../../types';

export const SectionHeightEditor: React.FC<{
  handleStyleChange: (value: string) => void;
  activeSectionId: string;
  activeSectionStyleSheet: string;
  activeSectionHeight: number;
}> = ({
  handleStyleChange,
  activeSectionId,
  activeSectionStyleSheet,
  activeSectionHeight,
}) => {
  const cssSectionHeight = getValueFromStyles(
    activeSectionStyleSheet,
    CSS_PROPERTIES.MIN_HEIGHT,
  );
  const [sectionHeightValue, sectionHeightUnit] = splitValueAndUnit(
    cssSectionHeight
      ? cssSectionHeight
      : `${activeSectionHeight}${HEIGHT_UNITS.PX}`,
  );

  const [sectionHeight, setSectionHeight] = React.useState(
    Number(sectionHeightValue),
  );
  const [selectedHeightUnit, setSelectedHeightUnit] =
    React.useState(sectionHeightUnit);

  React.useEffect(() => {
    setSectionHeight(Number(sectionHeightValue));
  }, [sectionHeightValue, activeSectionId]);

  React.useEffect(() => {
    setSelectedHeightUnit(sectionHeightUnit);
  }, [sectionHeightValue, activeSectionId, sectionHeightUnit]);

  const handleHeightChange = (newValue: string) => {
    setSectionHeight(Number(newValue));
    if (setHeightLimits(sectionHeight) !== activeSectionHeight) {
      handleStyleChange(
        `${CSS_PROPERTIES.MIN_HEIGHT}: ${setHeightLimits(Number(newValue))}${selectedHeightUnit};`,
      );
    }
  };

  return (
    <Form.Row>
      <Form.Group>
        <StyledInput
          type="number"
          prefix="H"
          value={sectionHeight?.toString()}
          onChange={handleHeightChange}
        />
      </Form.Group>

      <Form.Group>
        <Dropdown
          trigger={({ isOpen, ...triggerProps }) => (
            <Button
              variant="clean"
              isPressed={isOpen}
              rightIcon={<Dropdown.Arrow />}
              {...triggerProps}
            >
              {selectedHeightUnit === HEIGHT_UNITS.VH ? '%' : HEIGHT_UNITS.PX}
            </Button>
          )}
        >
          <Dropdown.Item onClick={() => setSelectedHeightUnit(HEIGHT_UNITS.PX)}>
            {HEIGHT_UNITS.PX}
          </Dropdown.Item>

          <Dropdown.Item onClick={() => setSelectedHeightUnit(HEIGHT_UNITS.VH)}>
            %
          </Dropdown.Item>
        </Dropdown>
      </Form.Group>
    </Form.Row>
  );
};

const setHeightLimits = (w: number) => {
  if (w < SECTION_MIN_HEIGHT) return SECTION_MIN_HEIGHT;
  if (w > SECTION_MAX_HEIGHT) return SECTION_MAX_HEIGHT;

  return w;
};
